import { redirect } from "@tanstack/react-router";

export const checkAuthorizationByRoles = (roles: string[]) => {
  if (!roles.includes("super-agent")) {
    throw redirect({
      to: "/",
    });
  }
};
